// extracted by mini-css-extract-plugin
export default {"singleSelect":"single-select_singleSelect__R7NEy","withLabel":"single-select_withLabel__oHv+o"};